// @ts-check
import { defineStore } from "pinia";
import FlowParticipationsApi, { type FlowParticipationResp } from "@/data/api-layer/flowParticipationsApi";

const useFlowParticipationStore = defineStore("flowParticipationStore", () => {
   type requestType = "getParticipation" | "getOrCreateParticipation" | "startPublicFlow" | "resumePublicFlow";

   // State
   // -----------------------------------------
   const flowParticipation = ref<FlowParticipationResp>(null);

   // Computed
   // -----------------------------------------
   const flowParticipationData = computed(() => flowParticipation.value?.data);
   const resumeCode = computed(() => flowParticipation.value?.data?.resumeCode);
   const token = computed(() => flowParticipation.value?.token);

   // Methods
   // -----------------------------------------
   async function setFlowParticipation(requestType: requestType, flowId: string, resumeCode?: string) {
      // Reset flowParticipation & flowParticipationResponseCode before making any of these requests, so that old values don't remain if a fetch is unsuccessful
      $reset();

      if (requestType === "getParticipation") {
         flowParticipation.value = await FlowParticipationsApi.getParticipation(flowId);
      } else if (requestType === "getOrCreateParticipation") {
         flowParticipation.value = await FlowParticipationsApi.getOrCreateParticipation(flowId);
      } else if (requestType === "startPublicFlow") {
         flowParticipation.value = await FlowParticipationsApi.startPublicFlow(flowId);
      } else if (requestType === "resumePublicFlow") {
         flowParticipation.value = await FlowParticipationsApi.resumePublicFlow(flowId, resumeCode, {});
      }
   }

   function $reset() {
      flowParticipation.value = null;
   }

   return {
      flowParticipation,
      flowParticipationData,
      resumeCode,
      token,
      setFlowParticipation,
      $reset,
   };
});

export { useFlowParticipationStore };
